/**
 * Tailwind Colors
 *
 * @see https://tailwindcss.com/docs/customizing-colors
 */

export enum SubstanceLogColors {
  GREEN_600 = '#2BA14C',
  YELLOW_600 = '#D1A419',
  ORANGE_600 = '#EA852C',
  RED_600 = '#E53F3F',
  RED_700 = '#A61C1C',
  RED_800 = '#7A1D1D',
  GRAY_500 = '#677D98'
}
export enum Color {
  AMBER = 'amber',
  BLACK = 'black',
  BLUE = 'blue',
  CYAN = 'cyan',
  EMERALD = 'emerald',
  GRAY = 'gray',
  GREEN = 'green',
  INDIGO = 'indigo',
  LIME = 'lime',
  NEUTRAL = 'neutral',
  ORANGE = 'orange',
  RED = 'red',
  SKY = 'sky',
  SLATE = 'slate',
  STONE = 'stone',
  TEAL = 'teal',
  WHITE = 'white',
  YELLOW = 'yellow',
  ZINC = 'zinc'
}

export const ColorVariants: { [key in Color]: string } = {
  [Color.AMBER]: 'text-amber-50 bg-amber-600',
  [Color.BLACK]: 'text-white bg-gray-900',
  [Color.BLUE]: 'text-blue-50 bg-blue-600',
  [Color.CYAN]: 'text-cyan-50 bg-cyan-600',
  [Color.EMERALD]: 'text-emerald-50 bg-emerald-600',
  [Color.GRAY]: 'text-uniform-white-base bg-uniform-gray-500',
  [Color.GREEN]:
    'text-green-50 bg-green-600 dark:bg-uniform-green-600 dark:text-uniform-white-base',
  [Color.INDIGO]: 'text-indigo-50 bg-indigo-600',
  [Color.LIME]: 'text-lime-50 bg-lime-600',
  [Color.NEUTRAL]: 'text-gray-50 bg-gray-600',
  [Color.ORANGE]: 'text-orange-50 bg-orange-600',
  [Color.RED]:
    'text-uniform-white-base bg-uniform-red-700 dark:text-uniform-white-base dark:bg-uniform-red-900',
  [Color.SKY]: 'text-sky-50 bg-sky-600',
  [Color.SLATE]: 'text-slate-50 bg-slate-600',
  [Color.STONE]: 'text-stone-50 bg-stone-600',
  [Color.TEAL]: 'text-teal-50 bg-teal-600',
  [Color.WHITE]: 'text-gray-900 bg-white',
  [Color.YELLOW]: 'text-white bg-yellow-600',
  [Color.ZINC]: 'text-zinc-50 bg-gray-600'
};

export const ColorBorder: { [key in Color]: string } = {
  [Color.AMBER]: 'border border-amber-700',
  [Color.BLACK]: 'border border-gray-800',
  [Color.BLUE]: 'border border-blue-700',
  [Color.CYAN]: 'border border-cyan-700',
  [Color.EMERALD]: 'border border-emerald-700',
  [Color.GRAY]: 'border border-uniform-gray-700',
  [Color.GREEN]: 'border border-green-700',
  [Color.INDIGO]: 'border border-indigo-700',
  [Color.LIME]: 'border border-lime-700',
  [Color.NEUTRAL]: 'border border-gray-700',
  [Color.ORANGE]: 'border border-orange-700',
  [Color.RED]: 'border border-uniform-red-800 dark:border-uniform-red-800',
  [Color.SKY]: 'border border-sky-700',
  [Color.SLATE]: 'border border-slate-700',
  [Color.STONE]: 'border border-stone-700',
  [Color.TEAL]: 'border border-teal-700',
  [Color.WHITE]: 'border border-gray-200',
  [Color.YELLOW]: 'border border-yellow-600',
  [Color.ZINC]: 'border border-zinc-700'
};

export const ColorVariantsLight: { [key in Color]: string } = {
  [Color.AMBER]: 'text-amber-900 bg-amber-100',
  [Color.BLACK]: 'text-black bg-gray-100',
  [Color.BLUE]: 'text-blue-900 bg-blue-100',
  [Color.CYAN]: 'text-cyan-900 bg-cyan-100',
  [Color.EMERALD]: 'text-emerald-900 bg-emerald-100',
  [Color.GRAY]: 'text-black bg-gray-100',
  [Color.GREEN]: 'text-green-900 bg-green-100',
  [Color.INDIGO]: 'text-indigo-900 bg-indigo-100',
  [Color.LIME]: 'text-lime-900 bg-lime-100',
  [Color.NEUTRAL]: 'text-gray-900 bg-gray-100',
  [Color.ORANGE]: 'text-orange-900 bg-orange-100',
  [Color.RED]: 'text-red-900 bg-red-50',
  [Color.SKY]: 'text-sky-900 bg-sky-100',
  [Color.SLATE]: 'text-slate-900 bg-slate-100',
  [Color.STONE]: 'text-stone-900 bg-stone-100',
  [Color.TEAL]: 'text-teal-900 bg-teal-100',
  [Color.WHITE]: 'text-black bg-white',
  [Color.YELLOW]: 'text-yellow-900 bg-yellow-100',
  [Color.ZINC]: 'text-zinc-900 bg-zinc-100'
};

export const ColorBorderLight: { [key in Color]: string } = {
  [Color.AMBER]: 'border border-amber-200',
  [Color.BLACK]: 'border border-gray-200',
  [Color.BLUE]: 'border border-blue-200',
  [Color.CYAN]: 'border border-cyan-200',
  [Color.EMERALD]: 'border border-emerald-200',
  [Color.GRAY]: 'border border-gray-200',
  [Color.GREEN]: 'border border-green-200',
  [Color.INDIGO]: 'border border-indigo-200',
  [Color.LIME]: 'border border-lime-200',
  [Color.NEUTRAL]: 'border border-gray-200',
  [Color.ORANGE]: 'border border-orange-200',
  [Color.RED]: 'border border-red-200',
  [Color.SKY]: 'border border-sky-200',
  [Color.SLATE]: 'border border-slate-200',
  [Color.STONE]: 'border border-stone-200',
  [Color.TEAL]: 'border border-teal-200',
  [Color.WHITE]: 'border border-gray-200',
  [Color.YELLOW]: 'border border-yellow-200',
  [Color.ZINC]: 'border border-zinc-200'
};

export const SUCCESS_GREEN_COLOR = 'text-green-600';
export const ERROR_RED_COLOR = 'text-red-700';
export const WARNING_ORANGE_COLOR = 'text-orange-600';
